import { action, thunk } from 'easy-peasy'

import { FetchStatus, Paginator } from '@types'

import { CategoryModel, categoryService } from '.'

export const category: CategoryModel = {
  paginator: {} as Paginator,
  categories: [],
  status: FetchStatus.LOADING,
  error: {},

  // Actions
  setPaginator: action((state, payload) => {
    state.paginator = payload
  }),
  setCategories: action((state, payload) => {
    state.categories = payload
  }),
  addCategories: action((state, payload) => {
    state.categories = [...state.categories, ...payload]
  }),
  setStatus: action((state, payload) => {
    state.status = payload
  }),
  setError: action((state, payload) => {
    state.error = payload
  }),

  // Thunks
  fetchAllCategory: thunk((action, payload) => {
    action.setStatus(FetchStatus.LOADING)
    categoryService
      .getAllCategory(payload)
      .then(({ data, paginator }) => {
        action.setPaginator(paginator)
        action.setCategories(data)
        action.setStatus(FetchStatus.LOADED)
        action.setError({})
      })
      .catch((e) => {
        action.setError(e)
        action.setStatus(FetchStatus.ERROR)
      })
  }),

  fetchMoreCategory: thunk((action, payload) => {
    action.setStatus(FetchStatus.FETCHING_MORE)
    categoryService
      .getAllCategory(payload)
      .then(({ data, paginator }) => {
        action.setPaginator(paginator)
        action.addCategories(data)
        action.setStatus(FetchStatus.LOADED)
        action.setError({})
      })
      .catch(() => {
        action.setStatus(FetchStatus.FETCHING_MORE_ERROR)
        action.setStatus(FetchStatus.LOADED)
      })
  })
}
